var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { SideImageLayout } from 'hx-ui';
import { pageImages } from '@/pages/images';
import { WelcomePageLayoutContent } from '@/components/welcome-page/components/welcome-page-layout-content.component';
import { WelcomeFooter } from '@/components/welcome-page/components/welcome-footer.component';
import bgGraphic from '@/assets/images/bg-graphic.svg';
export function WelcomePage() {
    return (_jsxs("div", __assign({ className: "relative" }, { children: [_jsx("img", { src: bgGraphic, alt: "", "aria-hidden": true, className: "pointer-events-none absolute bottom-0 right-0 z-0 hidden select-none md:block w-1/5" }), _jsx(SideImageLayout, { leftPanelWidth: "40%", className: "relative z-10", imageLeft: pageImages.family, imageStyle: {
                    backgroundSize: 'cover',
                    backgroundPosition: '50% 50%',
                    backgroundRepeat: 'no-repeat',
                }, classNames: {
                    imageLeft: 'border-r-primary border-r-8',
                }, header: _jsxs("header", __assign({ className: "text-center pt-8" }, { children: [_jsxs(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl leading-10 mb-4" }, { children: ["Test de", ' ', _jsx("span", __assign({ className: "font-normal text-primary" }, { children: "d\u00E9pistage" }))] })), _jsx(Typography, __assign({ variant: "h5", className: "font-normal text-xl" }, { children: "D\u00E9couvrez l'\u00E9tat de votre audition en 2 minutes*" }))] })), content: _jsx(WelcomePageLayoutContent, {}), footer: _jsx(WelcomeFooter, { className: 'pb-8' }) })] })));
}
